import { ACTIONS } from '../actions/tickets'

export const initialState = {
    database: [],
    appState: {
        getTicketsError: null,
        getTicketsLoading: false,
        currentTicketLoading: null,
        closeTicketError: null,
    },
}

export default (state = initialState, action) => {
    const { appState, database } = state
    switch (action.type) {
        case ACTIONS.GET_TICKETS.START:
            return {
                ...state,
                appState: { ...appState, getTicketsLoading: true },
            }
        case ACTIONS.GET_TICKETS.SUCCESS:
            const openedTickets = action.tickets.filter(({ ticketStatus }) => ticketStatus !== 'Ticket Closed')
            return {
                ...state,
                appState: { ...appState, getTicketsLoading: false, getTicketsError: null },
                database: openedTickets,
            }
        case ACTIONS.GET_TICKETS.FAILURE:
            return {
                ...state,
                appState: { ...appState, getTicketsLoading: false, getTicketsError: action.error },
            }

        case ACTIONS.CLOSE_TICKET.START:
            return {
                ...state,
                appState: {
                    ...state.appState,
                    currentTicketLoading: action.ticket.ticketId,
                },
            }
        case ACTIONS.CLOSE_TICKET.SUCCESS:
            return {
                ...state,
                database: [...database.filter(({ ticketId }) => ticketId !== action.ticket.ticketId)],
                appState: {
                    ...state.appState,
                    currentTicketLoading: null,
                    closeTicketError: null,
                },
            }
        case ACTIONS.CLOSE_TICKET.FAILURE:
            return {
                ...state,
                appState: {
                    ...state.appState,
                    currentTicketLoading: null,
                    closeTicketError: action.error,
                },
            }

        default:
            return state
    }
}
